import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import HomePage from './components/HomePage';
import Header from './components/Header';
import Footer from './components/Footer';
import CompanyRegistration from './components/CompanyRegistration';
import phone from './assets/images/mobile.png';
import whatsapp from './assets/images/whatsapp.png';
import PrivateLimitedCompany from './components/PrivateLimitedCompany';
import NGORegistration from './components/NGORegistration';
import LLPRegistration from './components/LLPRegistration';
import OPCRegistration from './components/OPCRegistration';
import PartnershipFirm from './components/PartnershipFirm';
import PublicLimitedCompany from './components/PublicLimitedCompany';
import Section8Company from './components/Section8Company';
import SocietyRegistration from './components/SocietyRegistration';
import SoleProprietorship from './components/SoleProprietorship';
import About from './components/About';
import ADCodeRegistration from './components/ImportExport/ADCodeRegistration';
import APEDARegistration from './components/ImportExport/APEDARegistration';
import IECRegistration from './components/ImportExport/IECRegistration';
import LUTRegistration from './components/ImportExport/LUTRegistration';
import RcmcRegistration from './components/ImportExport/RcmcRegistration';
import RodtepScheme from './components/ImportExport/RodtepScheme';
import UsFdaRegistration from './components/ImportExport/UsFdaRegistration';
import LLPClosure from './components/Closure/LLPClosure';
import OPCClosure from './components/Closure/OPCClosure';
import PrivateLimitedClosure from './components/Closure/PrivateLimitedClosure';
import Section8Closure from './components/Closure/Section8Closure';
import GSTRegistration from './components/Registration/GSTRegistration';
import ISOCertification from './components/Registration/ISOCertification';
import MSMERegistration from './components/Registration/MSMERegistration';
import PASARARegistration from './components/Registration/PASARARegistration';
import ProfessionalTaxRegistration from './components/Registration/ProfessionalTaxRegistration';
import FSSAIReturnFiling from './components/Compliance&TAX/FSSAIReturnFiling';
import GSTReturnFiling from './components/Compliance&TAX/GSTReturnFiling';
import IncomeTaxReturn from './components/Compliance&TAX/IncomeTaxReturn';
import ITRU from './components/Compliance&TAX/ITRU';
import TDSReturn from './components/Compliance&TAX/TDSReturn';
import AnnualFiling from './components/Compliance&TAX/AnnualFiling';
import TrademarkRegistration from './components/IPR/TrademarkRegistration';
import CopyrightRegistration from './components/IPR/CopyrightRegistration';
import PatentRegistration from './components/IPR/PatentRegistration';
import DesignRegistration from './components/IPR/DesignRegistration';
import GITagRegistration from './components/IPR/GITagRegistration';
import PlantVarietyRegistration from './components/IPR/PlantVarietyRegistration';
import SemiconductorLayout from './components/IPR/SemiconductorLayout';
import AdminPanel from './components/ADMIN/AdminPanel';
import AdminLogin from './components/ADMIN/AdminLogin';
import ProtectedRoute from "./components/ProtectedRoute";
import ClientFeedback from "./components/ClientFeedback";
import WebDevelopment from "./components/More/WebDevelopmentPackages"
import ConfidentialityPolicy from "./components/Policy/ConfidentialityPolicy"
import PrivacyPolicy from "./components/Policy/PrivacyPolicy";
import RefundTerms from "./components/Policy/RefundTerms";
import TermsConditions from "./components/Policy/TermsConditions";
import EcommerceAccounting from "./components/Compliance&TAX/EcommerceAccounting";


function Layout() {

  const location = useLocation();

  // Hide Header/Footer on Admin Pages
  const hideLayout = location.pathname.startsWith("/admin") || location.pathname === "/feedback";;


  return (

    <>
      {!hideLayout && <Header />}
      {/* <Header /> */}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/company-registration" element={<CompanyRegistration />} />
        <Route path="/private-limited" element={<PrivateLimitedCompany />} />
        <Route path="/ngo" element={<NGORegistration />} />
        <Route path="/llp" element={<LLPRegistration />} />
        <Route path="/opc" element={<OPCRegistration />} />
        <Route path="/partnership" element={<PartnershipFirm />} />
        <Route path="/public-limited" element={<PublicLimitedCompany />} />
        <Route path="/section-8" element={<Section8Company />} />
        <Route path="/society" element={<SocietyRegistration />} />
        <Route path="/sole" element={<SoleProprietorship />} />
        <Route path="/ad-code-registration" element={<ADCodeRegistration />} />
        <Route path="/apeda-registration" element={<APEDARegistration />} />
        <Route path="/import-export-code" element={<IECRegistration />} />
        <Route path="/lut-certificate" element={<LUTRegistration />} />
        <Route path="/rcmc-registration" element={<RcmcRegistration />} />
        <Route path="/rodtep-scheme" element={<RodtepScheme />} />
        <Route path="/us-fda" element={<UsFdaRegistration />} />
        <Route path="/llp-closure" element={<LLPClosure />} />
        <Route path="/opc-closure" element={<OPCClosure />} />
        <Route path="/private-limited-closure" element={<PrivateLimitedClosure />} />
        <Route path="/section-8-closure" element={<Section8Closure />} />
        <Route path="/gst-registration" element={<GSTRegistration />} />
        <Route path="/iso-certification" element={<ISOCertification />} />
        <Route path="/msme-registration" element={<MSMERegistration />} />
        <Route path="/pasar-registration" element={<PASARARegistration />} />
        <Route path="/professional-tax-registration" element={<ProfessionalTaxRegistration />} />
        <Route path="/fssai-return-filing" element={<FSSAIReturnFiling />} />
        <Route path="/GST-return-filing" element={<GSTReturnFiling />} />
        <Route path="/Income-tax-return" element={<IncomeTaxReturn />} />
        <Route path="/ITR" element={<ITRU />} />
        <Route path="/TDS" element={<TDSReturn />} />
        <Route path="/annual-filing" element={<AnnualFiling />} />
        <Route path="/trademark" element={<TrademarkRegistration />} />
        <Route path="/copyright" element={<CopyrightRegistration />} />
        <Route path="/patent" element={<PatentRegistration />} />
        <Route path="/design-registrattion" element={<DesignRegistration />} />
        <Route path="/gi-tag" element={<GITagRegistration />} />
        <Route path="/plant-variety" element={<PlantVarietyRegistration />} />
        <Route path="/semiconductor-layout" element={<SemiconductorLayout />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/feedback" element={<ClientFeedback />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/confidentialityPolicy" element={<ConfidentialityPolicy />} />
        <Route path="/privacy-Policy" element={<PrivacyPolicy />} />
        <Route path="/refundPolicy" element={<RefundTerms />} />
        <Route path="/termsConditions" element={<TermsConditions />} />
        <Route path="/about" element={<About />} />
        <Route path="/acommerceaccounting" element={<EcommerceAccounting />} />

        <Route path="/admin-panel" element={
          <ProtectedRoute>
            <AdminPanel />
          </ProtectedRoute>
        }
        />
      </Routes>




      {/* <Footer /> */}
      {!hideLayout && <Footer />}

      {/* FLOATING ICONS */}
      {!hideLayout && (<div className="floating-icons">

        {/* WhatsApp */}
        <a
          href="https://wa.me/919218103915"
          target="_blank"
          rel="noopener noreferrer"
          className="float-btn whatsapp"
        >
          <img src={whatsapp} alt="WhatsApp" />
        </a>

        {/* Call */}
        <a
          href="tel:+919218103915"
          className="float-btn call"
        >
          <img src={phone} alt="Call" />
        </a>

      </div>
      )}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;